module.exports = __webpack_public_path__ + "img/when.be5030ca.webp";